<template>
    <div>
        <v-card
            flat>
            <v-card-title>
                {{ $t('EXT_WORKSHOPS_TITLE') }}
                <v-spacer></v-spacer>
                <v-text-field
                    :label="$t('EXT_WORKSHOPS_SEARCH')"
                    v-model="search"
                    class="ml-4"
                    @keypress.enter="createDataFetch()">
                </v-text-field>
                <v-btn v-if="selected.externalWorkshops.length" @click="openExternalWorkshopDisplayDialog({ id : selected.externalWorkshops[0].id })" icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            link
                            v-if="authorizations.external_workshops.create"
                            @click="openExternalWorkshopDialog({editMode: false})" 
                            >
                            <v-list-item-avatar>
                               <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>
                                {{ $t('new_external_workshop') }}
                            </v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            v-if="authorizations.external_workshops.update && selected.externalWorkshops.length == 1"
                            link
                            @click="openExternalWorkshopDialog({editMode: true, id: selected.externalWorkshops[0].id})"
                            :disabled="!selected.externalWorkshops[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.externalWorkshops[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.external_workshops.delete && selected.externalWorkshops.length == 1"
                            link
                            @click="openExternalWorkshopDeleteDialog(selected.externalWorkshops[0].id)"
                            :disabled="!selected.externalWorkshops[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.externalWorkshops[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>
                {{ $t('EXT_WORKSHOPS_SUBTITLE') }}
            </v-card-subtitle>
            <v-card-text>
                <v-data-table
                    dense
                    :items="externalWorkshops"
                    :headers="externalWorkshopsHeaders"
                    single-select
                    show-select
                    v-model="selected.externalWorkshops"
                    :loading="loading.data"
                    :options.sync="options"
                    :server-items-length="externalWorkshopsLength"
                    :search="search">
                </v-data-table>
            </v-card-text>
        </v-card>
        <ExternalWorkshopDialog
            ref="externalWorkshopDialog"
            @submit="createDataFetch()"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <ExternalWorkshopDisplayDialog
            ref="externalWorkshopDisplayDialog"/>
    </div>
</template>

<script>
import ExternalWorkshopDisplayDialog from '@/components/ExternalWorkshopDisplayDialog';
import ExternalWorkshopDialog from "../components/ExternalWorkshopDialog";
import AlertDialog from "../components/AlertDialog";
import DecisionDialog from "../components/DecisionDialog";
import { mapActions, mapState } from 'vuex';
export default {
    name: "ExternalWorkshop",
    components: {
       ExternalWorkshopDialog,
       DecisionDialog,
       AlertDialog,
       ExternalWorkshopDisplayDialog 
    },
    data() {
        return {
            externalWorkshopsLength: 0,
            search: null,
            selected: {
                externalWorkshops: []
            },
            externalWorkshopsHeaders: [
                {text: this.$t('EXT_WORKSHOP_NAME'), value: "name"},
                {text: this.$t('EXT_WORKSHOP_PHONE'), value: "phone"},
                {text: this.$t('EXT_WORKSHOP_ADDRESS'), value: "address"}
            ],
            loading: {
                data: true,
                externalWorkshops: false
            },
            options: {}
        }
    },
    computed: {
        ...mapState("externalWorkshop", ["externalWorkshops"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    watch: {
        options: {
            handler () {
                this.createDataFetch();
            }
        }
    },
    methods: {
        ...mapActions("externalWorkshop", ["fetchExternalWorkshops", "removeExternalWorkshop"]),
        openExternalWorkshopDialog(params) {
            this.$refs.externalWorkshopDialog.open(params);
        },
        async createDataFetch() {
            try {
                this.loading.data = true;
                this.options.search = this.search;
                let result = await this.fetchExternalWorkshops(this.options);
                this.externalWorkshopsLength = result.data.total;
                this.loading.data = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
            }
        },
        openExternalWorkshopDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE_EXTERNAL_WORKSHOP",
                id: id
            });
        },
        openExternalWorkshopDisplayDialog(params){
            this.$refs.externalWorkshopDisplayDialog.open(params);
        },
        submitDecisionDialog(payload) {
            if(payload.action == "DELETE_EXTERNAL_WORKSHOP") {
                this.removeExternalWorkshop(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.createDataFetch();
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    })
            }
        }
    },
    created() {
        this.createDataFetch();
    }
}
</script>